export default __webpack_public_path__ + "static/media/comment.b9bb6025.svg";